<section class="consejo-directivo mb-5">
  <div class="row m-0 header justify-content-center text-center">
    <h1 class="title">Mensaje del Presidente</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-lg-2 col-md-1 col-0"></div>
    <div class="alert alert-light text-center" *ngIf="loading">
      <p class="d-flex justify-content-center">
        <mat-spinner diameter="80"></mat-spinner>
      </p>
    </div>

    <div
      class="col-12 col-md-9 col-lg-8 justify-content-center"
      *ngIf="mensajes.length === 0 && !loading"
    >
      <div class="text-center">
        <h1>
          <span class="sorry-line">¡Lo sentimos!</span><br />Por el momento no
          hay ningún mensaje del Presidente {{ director?.nombre }}
          {{ director?.aPaterno }}
          {{ director?.aMaterno }}
        </h1>
      </div>
    </div>

    <div
      class="col-12 col-md-10 col-lg-8 justify-content-center"
      *ngIf="!loading && mensajes.length > 0"
    >
      <!-- Tarjetas de Mensajes starts -->
      <div class="msg-container">
        <div class="row equal">
          <div class="col-xl-4 col-12 text-center">
            <img
              [src]="director?.avatarUri"
              [alt]="director?.nombre"
              height="250"
            />
          </div>
          <div class="col-xl-8 col-12 mt-md-4 mt-3 text-left">
            <div class="date-container"></div>
            <h3 class="text-muted text-right date">
              <strong
                >{{ ultimoMensaje?.vigenteDesde | date: "mediumDate" }} -
                {{ ultimoMensaje?.vigenteHasta | date: "mediumDate" }}</strong
              >
            </h3>
            <h2 class="mt-md-3">
              Mensaje del Presidente |
              <strong
                >{{ director?.nombre }} {{ director?.aPaterno }}
                {{ director?.aMaterno }}</strong
              >
            </h2>
            <h3 class="message" [innerText]="ultimoMensaje?.mensaje"></h3>
          </div>
        </div>
      </div>
      <hr />
      <div class="botonera text-center" *ngIf="mensajes.length > 1">
        <button
          class="btn btn-blue-cat"
          *ngIf="!showMore"
          (click)="showMore = !showMore"
        >
          Mostrar más...
        </button>
      </div>

      <div class="viejos-mensajes-container" *ngIf="showMore">
        <div class="msg-container" *ngFor="let mensaje of primerosMensajes">
          <div class="row equal">
            <div class="col-xl-4 col-12 text-center">
              <img
                [src]="director?.avatarUri"
                [alt]="director?.nombre"
                height="250"
              />
            </div>
            <div class="col-xl-8 col-12 mt-md-4 mt-3 text-left">
              <div class="date-container"></div>
              <h3 class="text-muted text-right date">
                <strong
                  >{{ mensaje?.vigenteDesde | date: "mediumDate" }} -
                  {{ mensaje?.vigenteHasta | date: "mediumDate" }}</strong
                >
              </h3>
              <h2 class="mt-md-3">
                Mensaje del Presidente |
                <strong
                  >{{ director?.nombre }} {{ director?.aPaterno }}
                  {{ director?.aMaterno }}</strong
                >
              </h2>
              <h3 class="message" [innerText]="mensaje?.mensaje"></h3>
            </div>
          </div>
        </div>
      </div>

      <div class="botonera text-center">
        <button
          class="btn btn-blue-cat"
          *ngIf="showMore"
          (click)="showMore = !showMore"
        >
          Ocultar viejos mensajes
        </button>
      </div>
      <!-- Tarjetas de Mensajes ends -->
    </div>
    <div class="col-lg-2 col-md-1 col-0"></div>
  </div>
</section>
